import React from "react";
import { Box, Typography } from "@mui/material";
import EnergyFlowBreakdownChart from "./EnergyFlowBreakdownChart";
import EnergyFlowTrends from "./EnergyFlowTrends";

const EnergyFlowAnalysis = ({ startDate, endDate, globalFilters = {}, onShowDetails }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            {/* Section Header */}
            <Box>
                <Typography
                    variant="fw400s20c000"
                    sx={{
                        lineHeight: "28px",
                        fontWeight: 300,
                    }}
                >
                    Energy Flow Analysis
                </Typography>
            </Box>

            {/* Energy Flow Breakdown Chart */}
            <EnergyFlowBreakdownChart
                startDate={startDate}
                endDate={endDate}
                globalFilters={globalFilters}
            />

            {/* Energy Flow Trends Chart */}
            <EnergyFlowTrends
                startDate={startDate}
                endDate={endDate}
                globalFilters={globalFilters}
                onShowDetails={onShowDetails}
            />
        </Box>
    );
};

export default EnergyFlowAnalysis;
